export type ButtonType =
  | 'primary'
  | 'primary-outline'
  | 'secondary'
  | 'secondary-outline';
export function getButtonVariant(
  variant: ButtonType,
  isLoading?: boolean,
  disabled?: boolean
) {
  if (disabled && !isLoading) {
    return 'bg-ds-grey-200 text-white border-transparent cursor-not-allowed';
  }
  switch (variant) {
    case 'primary':
      return 'text-white bg-ds-purple-600 transition-colors border-transparent hover:bg-ds-purple-400 focus:bg-ds-purple-800';
    case 'primary-outline':
      return 'text-ds-purple-600 bg-white hover:text-ds-purple-600 hover:border-ds-purple-600 border-ds-purple-600 focus:bg-ds-grey-900 hover:bg-ds-purple-600/5';
    case 'secondary':
      return 'text-ds-purple-600 bg-white border-transparent hover:shadow-silver transition-all duration-300 ease-in-out focus:bg-ds-blue-100';
    case 'secondary-outline':
      return 'bg-white border-ds-grey-200 hover:shadow-sm focus:bg-ds-grey-50';
  }
}

export type ButtonSize = 'l' | 'm' | 's';
export const getButtonSize = (size: ButtonSize) => {
  switch (size) {
    case 'l':
      return 'py-4 px-6 text-l h-14';
    case 'm':
      return 'py-2 px-4 h-10';
    case 's':
      return 'py-4 px-4 h-8';
  }
};
